var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M751.986793 730.293725c70.711482-74.880431 114.108874-175.797865 114.108874-286.673092 0-230.41274-187.454346-417.866063-417.866063-417.866063S30.363542 213.208916 30.363542 443.621657c0 230.411717 187.454346 417.866063 417.866062 417.866062 101.129258 0 193.975876-36.105313 266.336928-96.108918l258.149455 238.804874 34.744315-37.558407-255.473509-236.331543z m-303.757189 80.027661c-202.199165 0-366.700753-164.501588-366.700753-366.700753S246.030439 76.91988 448.229604 76.91988 814.930357 241.421468 814.930357 443.620633c0 202.200188-164.501588 366.700753-366.700753 366.700753zM465.237977 266.60708h-51.16531v167.166278H246.906389v51.16531h167.166278V652.104945h51.16531V484.938668h167.166277v-51.16531H465.237977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPlus);
export default __webpack_public_path__ + "static/media/searchPlus.18880d11f068cf7bc3f2c791e1022ea9.svg";
export { ForwardRef as ReactComponent };